import { useState } from 'react';

const useProgressCallback = () => {
  const [rtlMessage, setRtlMessage] = useState({ step: 'Request has been queued...' });

  const onProgressCallback = (data: { step: string; progress: number }) => {
    setRtlMessage(data ?? { step: 'Working...' });
  };

  return [onProgressCallback, { rtlMessage }] as const;
};

export { useProgressCallback };
